<!-- 产品-设备重复详情 -->
<template>
  <div class="md-layout">
    <!-- 卡片-设备重复详情表格 -->
    <div class="md-layout-item md-size-100">
      <md-card class="full-screen">
        <!-- 卡片-主体 -->
        <md-card-content>
          <div class="main-title">
            {{$I18n("uid_auht")}}
          </div>
          <form-item :label="$I18n('appli_type')">
            <el-select disabled v-model="formData.Form.auth_type" :placeholder="$I18n('uid_auth')">
              <el-option :value="1" :label="$I18n('uid_auht')" />
            </el-select>
          </form-item>
          <form-item :label="$I18n('cloud_plat_type')">
            <el-select v-model="formData.Form.sys" :placeholder="$I18n('user_reg_acc_02')">
              <el-option v-for="item in sysOptions" :key="item.sys" :value="item.sys" :label="item.name" />
            </el-select>
          </form-item>
          <form-item v-if="UserInfo.role_id < 10000" :label="$I18n('batch_id')">
            <el-input v-model="formData.Form.batch_id" :placeholder="$I18n('batch_id')"/>
          </form-item>
          <form-item :key="attach" :label="$I18n('attach')" :required="true" :custom="true">
            <file-uploader 
              style="margin-left: 6px;"
              @change="changeFile"
              :typeFilter="['xlsx', 'xls', 'xlsm', 'xlsb', 'csv']"
              :sizeFilter_max="10"
              :nameUseTime="true"
            >
              <div v-if="!formData.Form.file_url" class="imagebox">
                <img style="width:53px;" src="/img/upload.svg">
                <div style="margin-top: 6px;">
                  <span style="text-transform: initial;">
                    {{$I18n("drag_file_01")}}
                    <i class="info-color" style="color: rgb(55, 199, 199); font-style: normal;">{{$I18n("drag_file_02")}}</i>
                  </span>
                </div>
              </div>
              <div v-else class="imagebox">{{formData.Form.file_url.split("_").pop()}}</div>
            </file-uploader>
          </form-item>
          <div :style="{marginLeft: $router.history.current.query.lang == 'zh' ?'106px' :'206px',color:'#888888' }">{{$I18n("drag_file_limit_01")}}</div>
          <div style="text-align: center;width: 600px;margin-top: 120px;">
            <a href="/files/lic.xlsx" :download='"lic.xlsx"'>
              <div class="mini-button">
                {{$I18n("frame")}}
              </div>
            </a>
            <div class="mini-button" @click="reset">
              {{$I18n("reset")}}
            </div>
            <div class="mini-button md-info" @click="submit">
              {{$I18n("submit")}}
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import {  FormClass, /* timestampToString nMonthsAgo,  */ } from "@/common/tools.js";
import FormItem from "./UidAuth/FormItem.vue"
import FileUploader from "@/components/Common/FileUploader";
// import uploader from 'vue-simple-uploader'

export default {
  components: {
    FormItem, FileUploader,
  },
  props:["userinfo_sys"],
  data() {
    return {
      attach: 1,
      sysOptions: [],
      formData: new FormClass({
        sys     :this.userinfo_sys,
        file_url:"",
        batch_id:"",
        auth_type:1,
      },{
        sys     :"required",
        file_url:"required",
        // batch_id:"required",
        auth_type:"required",
      }),

    };
  },
  mounted : function() {
    this.api_getSysData();
  },
  watch: { },
  methods: {
    onFileAdded(file) {
      console.log('文件：', file)
    },
    // 弹窗用过
      changeFile(value){
        this.formData.Form.file_url = value;
        if(value){
          this.$successMsg(this.$I18n("upload_success"))
        }
      },

      submit(){
        if(this.formData.Check()){
          if(this.formData.Error.file_url){
            this.$errorMsg(this.$I18n("pls_uoload_file_02"))
          } else {
            this.$errorMsg(this.$I18n("pls_check_verify"))
          }
          return
        }
        this.$api.addLicAuth({
          ...this.formData.Form,
        })
          .then(() => {
            this.reset();
            this.$successMsg(this.$I18n("sub_succ"))
          })
          .catch(this.$Catch(this.$I18n("get_error")))
      },
      reset(){
        this.formData.Reset();
        this.attach = this.attach + 1;
      },
      api_getSysData(){
        return this.$api.getSysList({
          type  : "sys",
          option: {},
        })
          .then(this.$Then(res => {
            this.sysOptions = res.data;
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.sysOptions = [];
          }))
      },
  },
  computed: { 
    showFileUrl(){
      if(!this.formData.Form.file_url){
        return ""
      }
      let name = ""
      const split_file = this.formData.Form.file_url.split("_");
      if(split_file.length === 1){
        name = split_file[0].split("/").pop();
      } else if(split_file.length > 0){
        name = split_file.pop();
      }
      return name
    }
  },
}
</script>
<style lang="css" scoped>
  .my-uploader-css /deep/ .uploader-drop{
    background: unset;
    border-color: #DCDFE6;
    border-radius: 5px;
    width: 338px;
    cursor: pointer;
  }
  .imagebox{
    width: 100%;
    padding:17px 0 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    min-height: 123.500px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .main-title{
    border-left: 3px solid #00bcd4;
    font-size: 13px;
    color: #333;
    font-weight: 700;
    padding-left: 6px;
    line-height: 20px;
    margin: 10px 15px 20px 0px;
  }
  .info-color{
    color: rgb(55, 199, 199);
    font-style: normal;
    font-weight: 500;
  }
</style>